import apiUrl from '../../../../constants'
import axios from 'axios'
//import Paginate from 'vuejs-paginate';
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import download from 'downloadjs';
import Loader from './../../shared/loader'
import Pagination from './../../shared/pagination'
import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
Vue.component("downloadExcel", JsonExcel);
export default {
	name: 'notinporeport',
	components: {
		//Paginate,
		BasicSelect,
		Pagination,
		DatePicker,
		download,
		JsonExcel,
		Loader
	},
	props: [],
	data() {
		return {
			selectedmerchant: { value: '', text: '' },
			merchantList: [],
			merchantId: '',
			listMerchantIdData: [],
			merchantnameFlt: '',
			isLoadingforxls: false,
			csvFieldsForXls: {},
			listReportDataforxls: [],
			totalRows: 0,
			// currentPage: 0,
			notinPOReportData: [],
			notinPOReportDatacsv: [],
			csvFields: [],
			// perPage: 10,
			// pageno: 0,
			// pageCount: 0,
			totalPage: 0,
			// totalCount:0,
			currentPage: 1,
			pageLimit: 10,
			productid: '',
			isLoading: false,
			searchFlag: false,
			formattedDate: '',
			resultCount: 0,
			listClientData: [],
			listWarehouseData: [],
			ClientErr: '',
			WarehouseErr: '',
			searchFlag: false,
			showSelectWarehouse: false,
			showSelectClient: false,
			showSelectMerchant: false,
			clientid: '',
			warehouseid: '',
			warehouse: '',
			client: '',
			fromdate: '',
			todate: '',
			invreferenceid: '',
			user_type: '',
			userid: '',
			show: false,
			download: true,
			dataFilter2: '',
			reportname: '',
			limitExeed: false,
			recordLimit: 0,
			mid: '',
			listMerchantData: [],
			merchantname: '',
			merchant: '',
			item: {},
			listMerchantData1: [],
			merchantList: [],
			activemrpflag:false,
		}
	},
	computed: {

	},
	filters: {
		moment: function (date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
	},
	mounted() {
		this.calldateFunction();
		let permissionEncrypt = window.localStorage.getItem('userdetail');
		let bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		let plaintext = bytes.toString(CryptoJS.enc.Utf8);
		let userdetail = JSON.parse(plaintext);
		this.createdbyEmail = userdetail.email;
		this.userid = userdetail.userid;
		let today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss');
		this.reportname = this.$t('editedjson.notInPOReport');
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if(this.clientid!=='undefined'){
			this.getMerchantList();
        }
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				this.showSelectMerchant = true;
				this.showSelectWarehouse = true;
				this.getMerchantList()
				// this.getWarehouseList();
				this.getActiveMrpFlag();
				if (userdetail.merchantid != null) {

					this.mid = userdetail.merchantid.toString()
					this.merchantnameFlt = this.mid
					this.showSelectMerchant = false;
				}
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectMerchant = true;
				this.showSelectClient = true;
				// this.getClientList();
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
		this.getRecordLimit()

	},
	methods: {
		reset() {
			this.item = {}
		},
		onSelect(item) {
			this.item = item
			this.merchantnameFlt = item.value
		},
		calldateFunction: function () {
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
			this.todate = this.currentDate;
			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 6);
			this.fromdate = dt;
		},
		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({

			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRecordLimit',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;


					}
				}, error => {
					console.error(error)
				})
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getNotinPOReportDataForXls(3)

			}
		},
		export(data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},

		// getClientList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {

		// 		let userToken = window.localStorage.getItem('userToken');
		// 		let myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },

		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {

		// 		let userToken = window.localStorage.getItem('userToken')
		// 		let myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				// console.log(result.data.data);
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },

		// clientSelected() {
		// 	if (this.clientid != this.client || this.clientid == this.client) {
		// 		this.clientid = this.client;
		// 		this.merchantname = '';
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = [];
		// 			this.merchantList = []
		// 			this.selectedmerchant = {}
		// 			this.getWarehouseList();
		// 			this.getMerchantList();
		// 			this.getActiveMrpFlag();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = '';
		// 			}
		// 		}
		// 		this.merchantList = []
		// 		this.selectedmerchant = {}
		// 		this.getMerchantList();
		// 		this.getActiveMrpFlag();
		// 	}
		// 	this.notinPOReportData = [];
		// 	this.pageno = this.pageCount = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.pageCount = 0;
		// 	if (this.warehouseid) {
		// 		if (!this.clientid) {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		getMerchantList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: this.clientid,
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'merchantList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
						this.item = {
							value: '',
							text: ''
						};
						this.listMerchantData1 = [{
							value: '',
							text: this.$t('common.selectMerchantPlaceHolder')
						}];
						this.listMerchantData.forEach(ele => {
							this.listMerchantData1.push({
								"value": ele.merchantid,
								"text": ele.merchantname
							})
						})

					}

				}, error => {
					console.error(error)
				})
		},
		async getActiveMrpFlag(){
 				 var userToken = window.localStorage.getItem('userToken');
 				 var myStr = userToken.replace(/"/g, '');
 				 this.input = ({
 					 "clientid": this.clientid,
 				 });
 			 try {

 					 axios({
 							 method: 'POST',
 							 'url': apiUrl.api_url + 'checkActivemrpFlg',
 							 'data': this.input,
 							 headers: {
 								 'Authorization': 'Bearer ' + myStr,
 							 }
 						 })
 						 .then(result => {
 							 if(result.data.data.data[0].value ==='yes'){
 								 this.activemrpflag = true;
 							 }else{
 								 this.activemrpflag = false;
 							 }
 						 }, error => {
 							 console.error(error);
 						 });

 				 } catch (err) {
 					 throw new Error(err);
 				 }
 	 },
		getNotinPOReportserach() {
			this.currentPage = 1;
			this.searchFlag = true;
			this.getNotinPOReportData(2)
		},
		//to get client list
		getNotinPOReportData(csvCheck = 0) {
			let userToken = window.localStorage.getItem('userToken');
			let myStr = userToken.replace(/"/g, '');
			let fr_date = '';
			let to_date = '';
			var dataFilter = {};
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
				this.limitExeed = false;
			}
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageNo = this.pageCount = 0;
				this.notinPOReportData = [];
				return false;
			}
			if(window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.pageCount = 0;
				this.notinPOReportData = [];
				return false;
			}

			this.isLoading = true;

			if (this.fromdate == '') {
				fr_date = '';
			} else {
				fr_date = this.dateFormat(this.fromdate, 0);
			}
			if (this.todate == '') {
				to_date = '';
			} else {
				to_date = this.dateFormat(this.todate, 1);
			}

			if (csvCheck == 2)
				this.pageno = 0;
			this.input = ({
				clientid: this.clientid,
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				invreferenceid: this.invreferenceid,
				productid: this.productid,
				fromddate: fr_date,
				todate: to_date,
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				csvData: csvCheck,
				userid: this.userid,
				merchantid: this.merchantnameFlt,

			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'notInPOReport',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 1) {
						if (result.data.data.length > 0) {
							this.show = true;
							this.download = false;
							this.notinPOReportDatacsv = [];
							this.csvFields = {
								'invreferenceid':  this.$t('stockAgeingReport.table.drId'),
								'productid': this.$t('common.productId'),
								'eancode':  this.$t('inwardList.printData.productDetails.eanCode'),
								'productname': this.$t('printProductDetails.productName'),
								'qty': this.$t('orders.productQuantity'),
								'mrp': this.$t('removeHold.productMrp'),
								'activemrp': this.$t('common.activemrp'),
								'storeinqty': this.$t('editedjson.putawayQuantity'),
								'createdby': this.$t('cancelPutawayPendingReport.createdUser'),
								'createddate': this.$t('common.createdDate'),
								'modifiedby': this.$t('cancelPutawayPendingReport.putawayUser'),
								'modifieddate': this.$t('removeHold.putawayDate'),
								'merchantname': this.$t('common.merchant'),


							};
							let dateFilter = [];
							if(this.activemrpflag === true){
								var skipFilter = ['count', 'id', 'merchantid'];
							}else {
								var skipFilter = ['count', 'id', 'merchantid','activemrp'];
							}
							this.notinPOReportDatacsv = result.data.data;

							csvHelper.data.jsonToCSV(this.$t('editedjson.notInPOReport'), this.notinPOReportDatacsv, this.csvFields, dateFilter, skipFilter, dataFilter);

							// this.jsonToCSV('NotInPOReport', this.notinPOReportDatacsv, this.csvFields, dateFilter, skipFilter);
						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					} else {
						this.notinPOReportData = [];
						if (result.data.errorCode == -1) {
							this.$alertify.error(result.data.msg);
							this.resultCount = 0;
							this.totalRows = 0;
						} else {
							this.totalRows = Number(result.data.count);
							if (Number(this.totalRows) > Number(this.recordLimit)) {
								this.limitExeed = true
							}
							this.resultCount = result.data.count;

							if (result.data.data)
								this.notinPOReportData = result.data.data;

							if (this.totalRows <= this.pageLimit) {
								this.totalPage = 1;
							} else {
								this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
							}
						}
					}
					this.isLoading = false;
				}, error => {
					console.error(error);
				})
		},
		getNotinPOReportDataForXls(csvCheck = 0) {
			let userToken = window.localStorage.getItem('userToken');
			let myStr = userToken.replace(/"/g, '');
			let fr_date = '';
			let to_date = '';
			var dataFilter = {};
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';

			if (this.fromdate == '') {
				fr_date = '';
			} else {
				fr_date = this.dateFormat(this.fromdate, 0);
			}
			if (this.todate == '') {
				to_date = '';
			} else {
				to_date = this.dateFormat(this.todate, 1);
			}

			if (csvCheck == 2)
				this.pageno = 0;
			this.input = ({
				clientid: this.clientid,
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				invreferenceid: this.invreferenceid,
				productid: this.productid,
				fromddate: fr_date,
				todate: to_date,
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				csvData: csvCheck,
				userid: this.userid,
				merchantid: this.merchantnameFlt,

			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'notInPOReport',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 3) {
						if (result.data.data.length > 0) {
							this.listReportDataforxls = [];
							this.csvFieldsForXls =[];
							this.csvFieldsForXls[this.$t('stockAgeingReport.table.drId')] =  'invreferenceid';
							this.csvFieldsForXls[this.$t('product.productId')] = 'productid';
							this.csvFieldsForXls[this.$t('common.eanCode')] = 'eancode';
							this.csvFieldsForXls[this.$t('product.productName')] =  'productname';
							this.csvFieldsForXls[this.$t('orders.productQuantity')] = 'qty';
							this.csvFieldsForXls[this.$t('removeHold.productMrp')] =  'mrp';
							if(this.activemrpflag === true){
								this.csvFieldsForXls[this.$t('common.activemrp')] =  'activemrp';
							}
							this.csvFieldsForXls[this.$t('editedjson.putawayQuantity')] = 'storeinqty';
							this.csvFieldsForXls[this.$t('cancelPutawayPendingReport.createdUser')] ='createdby';
							this.csvFieldsForXls[this.$t('warehouseRacks.createdDate')] ='createddate';
							this.csvFieldsForXls[this.$t('cancelPutawayPendingReport.putawayUser')] ='modifiedby';
							this.csvFieldsForXls[this.$t('removeHold.putawayDate')] = 'modifieddate';
							this.csvFieldsForXls[this.$t('warehouseRacks.merchant')] = 'merchantname';


							this.listReportDataforxls = result.data.data;

						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}


					}


				}, error => {
					console.error(error);
				})
		},
		//to get pagination
		// getPaginationData(currentPage) {
		// 	this.pageno = (currentPage - 1) * this.perPage;
		// 	this.getNotinPOReportData();
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getNotinPOReportData()
		},
		dateFormat(date, toFrom) {
			if (!toFrom)
				toFrom = '00:00:00'
			else
				toFrom = '23:59:59'
			if (!date)
				return '';
			return moment(date).format('YYYY-MM-DD ' + toFrom);
		},

		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},

		//to reset search form
		resetSearchForm() {
			this.item = {}
			this.merchantnameFlt = '';
			this.show = false;
			this.download = true;
			this.searchFlag = false;
			this.productid = '';
			this.invreferenceid = '';
			this.pageno = 0;
			this.totalRows = 0;
			this.notinPOReportData = [];
			this.fromdate = '';
			this.todate = '';
			this.selectedmerchant = {}
			this.merchantList = []


			// if (this.user_type == 'warehouse_user')
			// 	this.client = '';
			// else if (this.user_type == 'client_user')
			// 	this.warehouse = '';
			// else {
			// 	this.client = '';
			// 	this.warehouse = '';
			// }
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/reports/notinporeport/notinporeport.component.js